import type { GarageKind, OwnedItem, Wallet } from '@accra/shared';
import { api } from './apiClient';

export type BuyResult = { ok: true; wallet: Wallet; owned: OwnedItem[] } | { ok: false; message: string };

export async function buyItem(key: string | null, kind: GarageKind, id: string, text?: string): Promise<BuyResult> {
  if (!key) return { ok: false, message: 'Connect to the internet to buy from the garage.' };
  const result = await api<{ wallet: Wallet; owned: OwnedItem[] }>('POST', '/garage/buy', key, { kind, id, ...(text ? { text } : {}) });
  if (!result) return { ok: false, message: 'Offline: try again when you have signal.' };
  if (!result.ok) return { ok: false, message: result.message || 'Could not buy that.' };
  return { ok: true, wallet: result.wallet, owned: result.owned };
}

export async function setName(key: string | null, name: string): Promise<string | null> {
  if (!key) return 'Offline: try again when you have signal.';
  const result = await api<{ name: string }>('PATCH', '/players/me', key, { name });
  if (!result) return 'Offline: try again when you have signal.';
  return result.ok ? null : result.message || 'That name is not allowed.';
}
